import MenuSidebar from '@/app/components/menuSidebar';
import Image from 'next/image';

const Video: React.FC = () => {
    const fixedChecked = true;
    return (
        <div className='wrapper max-w-10xl bg-white'>
            <div className='max-w-7xl mx-auto p-6 bg-white shadow-md rounded-lg 2xl:max-w-2xl lg:max-w-lg md:max-w-md sm:max-w-sm flex flex-col lg:flex-row gap-6'>
                <div className='flex-1'>
                    <h1 className="text-3xl font-bold mb-4">구성도</h1>
                    <div className="mb-6 text-gray-700">
                        화상감시시스템은 CCTV 카메라가 설치된 장소의 설비 및 침입자를 원격에서 네트워크를 통해 감시하여 실시간 현장 상황을 확인하고 관리하기 위한 시스템입니다.
                    </div>
 
                    <div className="mb-6">
                        <Image
                            src="/contents/image/videoDiagram.png"
                            alt="Video Surveillance Diagram"
                            width={800}
                            height={600} 
                            className="w-full h-auto object-cover rounded-lg shadow-md"
                        />
                    </div>

                    <h2 className="text-2xl font-semibold mb-4 mt-10">주요 기술 및 특징</h2>
                    <ul className="list-none space-y-4">
                        {[
                            '호환 / 연계: 표준 프로토콜을 준수 및 SDK 제공으로 기존 및 신설 기관 / 시스템과 호환',
                            '맞춤 서비스: 보유중인 센서, 네트워크, 영상인식 S/W 및 H/W 솔루션과 결합하여 설치목적과 요구에 맞는 통합관제 서비스 제공',
                            '검증된 서비스: NEP/EP 인증 획득(신제품, 성능인증) 및 조달우수제품 지정',
                            '웹브라우저 모니터링: 별도의 전용프로그램 없이 웹브라우저를 통해 네트워크가 연결된 장소 어디에서나 이용 가능',
                            '손실 없는 전송: H.264 / MPEG4 디지털 압축 영상을 인터넷을 통해 손실 없이 전송하여 다중 사용자 접속 시에도 원활한 감시 가능',
                            '실시간 듀얼 스트리밍: 영상 압축 모드 및 초당 프레임(최대 30)을 설정하여, PC와 모바일 등 용도에 맞게 듀얼 스트리밍 가능',
                            '카메라 설정 기능: 다양한 카메라 프로토콜(Pelco, Vicon, Samsung, Honeywell 등)을 탑재하여 고정형/회전형 감시카메라를 모두 지원 가능',
                            '외부 센서 연계: 온·습도계, 풍향/풍속계 등 다양한 센서와 연동하여 정확한 감지가 가능하며 화상감시뿐만 아니라 계측 장치로도 활용 가능'
                        ].map((text, index) => (
                            <li key={index} className="flex items-center">
                                <input
                                    type="checkbox"
                                    className="mr-2 accent-blue-600"
                                    checked={fixedChecked}
                                    readOnly
                                />
                                <span>{text}</span>
                            </li>
                        ))}
                    </ul>

                    <div className="flex justify-center mt-10">
                        <Image
                            src="/contents/image/videoFunction.png"
                            alt="Video Function"
                            width={1200} 
                            height={800} 
                            className="w-full h-auto object-cover max-w-screen-lg rounded-lg shadow-md mt-10"
                        />
                    </div>
                    
                    <h2 className="text-2xl font-semibold mb-4 mt-10">기능</h2>
                    <ul className="list-none space-y-2">
                        {[
                            'CCTV 영상 및 수집 정보의 통합 모니터링 서비스',
                            '실시간 영상 저장/분배/검색 서비스',
                            '알람 발생 이력 및 영상 조회 서비스',
                            '알람 발생 시 자동으로 카메라/조명 제어 및 수동 제어',
                            '디지털 영상 압축 알고리즘(MJPEG, MPEG-4, H.264)을 사용한 인터넷을 통한 실시간 영상 전송'
                        ].map((text, index) => (
                            <li key={index} className="flex items-center">
                                <input
                                    type="checkbox"
                                    className="mr-2 accent-blue-600"
                                    checked={fixedChecked}
                                    readOnly
                                />
                                <span>{text}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className='h-auto p-30px'>
                    <MenuSidebar category="UTM"/>
                </div>
            </div>
        </div>
    );
};

export default Video;
